import { Button, Checkbox, Form, Input, InputNumber, Radio, message } from "antd";
import { useState } from "react";
import { postForm } from "~@/API/fake";

const EditPrice = () => {
  const [form] = Form.useForm();
  const [loading,setLoading] = useState(false)
  const onFinish = async (values:any)=>{
    setLoading(true)
    setTimeout(async ()=>{
      const res = await postForm({...values,type:'批量修改价格'})
      setLoading(false)
      form.resetFields()
      message.success(res.originResponse.message)
    },2000)
  }
  return (
    <Form
      initialValues={{ productStatus: "1" }}
      form={form}
      layout="vertical"
      className="xl:max-w-[600px]"
      onFinish={onFinish}
    >
      <h2 className="font-medium mb-4 ">商品范围</h2>
      <Form.Item label="商品状态" name="productStatus">
        <Checkbox.Group
          options={[
            { label: "出售中", value: "1" },
            { label: "仓库中", value: "2" },
          ]}
        />
      </Form.Item>
      <Form.Item label="价格范围">
        <div className="flex items-center gap-x-2">
          <Form.Item name="priceMin" noStyle>
            <InputNumber placeholder="最低价" className="min-w-[220px]" />
          </Form.Item>
          <span> - </span>
          <Form.Item name="priceMax" noStyle>
            <InputNumber placeholder="最高价" className="min-w-[220px]" />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="库存范围">
        <div className="flex items-center gap-x-2">
          <Form.Item name="stockMin" noStyle>
            <InputNumber placeholder="最低库存" className="min-w-[220px]" />
          </Form.Item>
          <span> - </span>
          <Form.Item name="stockMax" noStyle>
            <InputNumber placeholder="最高库存" className="min-w-[220px]" />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item label="标题筛序">
        <div className="space-y-2">
          <div className="flex items-center   gap-x-2">
            <span className="flex-shrink-0">选择标题包含</span>
            <Form.Item noStyle>
              <Input placeholder="多个关键词用英文“,”隔开" />
            </Form.Item>
            <span className="flex-shrink-0">的商品</span>
          </div>
          <div className="flex items-center  gap-x-2">
            <span className="flex-shrink-0">排除标题包含</span>
            <Form.Item noStyle>
              <Input placeholder="多个关键词用英文“,”隔开" />
            </Form.Item>
            <span className="flex-shrink-0">的商品</span>
          </div>
        </div>
      </Form.Item>
      <Form.Item label="编码筛选">
        <div className="flex items-center  gap-x-2">
          <span className="flex-shrink-0">选择编码包含</span>
          <Form.Item noStyle>
            <Input placeholder="多个关键词用英文“,”隔开" />
          </Form.Item>
          <span className="flex-shrink-0">的商品</span>
        </div>
      </Form.Item>
      <h2 className="font-medium mb-4 ">修改内容</h2>
      <Form.Item>
        <div className="flex items-center gap-x-2">
          <span>修改范围</span>
          <Form.Item noStyle name="limit">
            <Radio.Group
              options={[
                { label: "全部sku", value: "0" },
                { label: "sku最低价", value: "1" },
                { label: "sku最高价", value: "2" },
              ]}
            />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item>
        <div className="flex items-center gap-x-2">
          <span>统一价格</span>
          <Radio>统一价格为</Radio>
          <InputNumber />
        </div>
      </Form.Item>
      <Form.Item>
        <div className="flex items-start gap-x-2">
          <span className="flex-shrink-0 h-[32px] flex items-center">
            <span>公式改价</span>
          </span>
          <div className="flex-1">
            <Form.Item noStyle>
              <Radio.Group className="grid items-center gap-x-2 grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-2 justify-start">
                {[
                  [
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 加</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                          <span>元</span>
                        </div>
                      ),
                      value: "1",
                    },
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 打</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                          <span>折</span>
                        </div>
                      ),
                      value: "2",
                    },
                  ],
                  [
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 减</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                          <span>元</span>
                        </div>
                      ),
                      value: "3",
                    },
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 涨</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                          <span>%</span>
                        </div>
                      ),
                      value: "4",
                    },
                  ],
                  [
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 乘</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                        </div>
                      ),
                      value: "5",
                    },
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 降</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                          <span>%</span>
                        </div>
                      ),
                      value: "6",
                    },
                  ],
                  [
                    {
                      label: (
                        <div className="flex items-center gap-x-2">
                          <span className="flex-shrink-0">原价 除</span>
                          <Form.Item noStyle>
                            <InputNumber
                              placeholder="请输入"
                              className="min-w-[160px]"
                            />
                          </Form.Item>
                        </div>
                      ),
                      value: "6",
                    },
                  ],
                ].map((items) => {
                  return items.map((option) => (
                    <Radio key={option.value} value={option.value}>
                      {option.label}
                    </Radio>
                  ));
                })}
              </Radio.Group>
            </Form.Item>
          </div>
        </div>
      </Form.Item>
      <Form.Item>
        <div className="flex items-start gap-x-2">
          <span className="flex-shrink-0 h-[32px] flex items-center">
            <span>尾数修改</span>
          </span>
          <div className="flex-1">
            <Form.Item noStyle>
              <Radio.Group className="grid items-center gap-2 justify-start">
                {[
                  {
                    label: (
                      <div className="flex items-center gap-x-2">
                        <span className="flex-shrink-0">统一位数</span>
                        <Form.Item noStyle>
                          <InputNumber
                            placeholder="请输入"
                            className="min-w-[120px]"
                          />
                        </Form.Item>
                        <span className="flex-shrink-0">个位</span>
                        <Form.Item noStyle>
                          <InputNumber
                            placeholder="请输入"
                            className="min-w-[120px]"
                          />
                        </Form.Item>
                        <span className="flex-shrink-0">角</span>
                        <Form.Item noStyle>
                          <InputNumber
                            placeholder="请输入"
                            className="min-w-[120px]"
                          />
                        </Form.Item>
                        <span className="flex-shrink-0">分</span>
                      </div>
                    ),
                    value: "1",
                  },
                  {
                    label: (
                      <div className="flex items-center gap-x-2">
                        <span className="flex-shrink-0">
                          价格小数位统一改为
                        </span>
                        <Form.Item noStyle>
                          <InputNumber
                            placeholder="请输入"
                            className="min-w-[370px]"
                          />
                        </Form.Item>
                      </div>
                    ),
                    value: "3",
                  },
                  {
                    label: (
                      <div className="flex items-center gap-x-2">
                        <span className="flex-shrink-0">
                          价格个位数统一改为
                        </span>
                        <Form.Item noStyle>
                          <InputNumber
                            placeholder="请输入"
                            className="min-w-[370px]"
                          />
                        </Form.Item>
                      </div>
                    ),
                    value: "5",
                  },
                ].map((option) => (
                  <Radio key={option.value} value={option.value}>
                    {option.label}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </div>
        </div>
      </Form.Item>
      <div className="space-x-4">
      <Button type="primary" htmlType="submit" loading={loading}>提交任务</Button>
      </div>
    </Form>
  );
};

export default EditPrice;
